import { render } from "./ContactIcon.vue?vue&type=template&id=e29b9dac&scoped=true"
import script from "./ContactIcon.vue?vue&type=script&lang=js"
export * from "./ContactIcon.vue?vue&type=script&lang=js"

import "./ContactIcon.vue?vue&type=style&index=0&id=e29b9dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29b9dac"]])

export default __exports__